import { useSession, useSessionExpiryModal } from 'providers';
import { useCallback, useEffect } from 'react';
import { AUTH_STEP } from '../AuthManager/constants';
import { useAuthManagerContext } from '../AuthManager/Context/useAuthManagerContext';
import { CodeVerificationModal } from '../SetupAccountModal/CodeVerificationModal';
import { EmailVerificationModal } from '../SetupAccountModal/EmailVerificationModal';
import { ForgotPasswordModal } from '../SetupAccountModal/ForgotPasswordModal';
import { PhoneVerificationModal } from '../SetupAccountModal/PhoneVerificationModal';
import { ExpiredSessionModal } from './ExpiredSessionModal';

export const ExpiredSessionManager = () => {
  const { step, setPrefilledEmail, setStep } = useAuthManagerContext();
  const { closeSessionExpiryModal, isModalOpen } = useSessionExpiryModal();
  const { user } = useSession();

  useEffect(() => {
    if (user?.email) {
      setPrefilledEmail(user?.email);
    }
  }, [setPrefilledEmail, user?.email]);

  const handleCompletedCodeVerification = useCallback(() => {
    closeSessionExpiryModal();
    // Since this component isn't unmounted after the user logs back in,
    // we need to set the step back to default so it opens in the correct
    // step next time
    setStep(AUTH_STEP.DEFAULT);
  }, [closeSessionExpiryModal, setStep]);

  switch (step) {
    case AUTH_STEP.DEFAULT:
      return <ExpiredSessionModal />;
    case AUTH_STEP.FORGOT_PASSWORD:
      return <ForgotPasswordModal />;
    case AUTH_STEP.EMAIL_VERIFICATION:
      return <EmailVerificationModal />;
    case AUTH_STEP.PHONE_VERIFICATION:
      return <PhoneVerificationModal />;
    case AUTH_STEP.TWO_FACTOR_AUTH:
      return (
        <CodeVerificationModal
          isNewPhone={false}
          open={isModalOpen}
          onCompleted={handleCompletedCodeVerification}
        />
      );

    case AUTH_STEP.TWO_FACTOR_VERIFICATION:
      return (
        <CodeVerificationModal
          isNewPhone={true}
          open={isModalOpen}
          onCompleted={handleCompletedCodeVerification}
        />
      );

    default:
      return null;
  }
};
